module.exports = __webpack_public_path__ + "static/media/pic.a4ce5128.png";